<template>
  <b-row>
    <!-- Column 1: Product Information -->
    <b-col>
      <h4 style="color='rgb(24, 28, 50)'">Thông tin sản phẩm</h4>

      <!-- Product Name -->
      <b-form-group class="required-control">
        <label class="d-block mt-4">Tên sản phẩm:</label>
        <b-form-input
          size="sm"
          v-model="localValue.name"
          placeholder="Nhập tên sản phẩm"
          :state="validationState('name')"
          @change="
            onValueChanged('name');
            $emit('generate-child');
          "
        ></b-form-input>
        <b-form-invalid-feedback>
          Yêu cầu nhập Tên sản phẩm.
        </b-form-invalid-feedback>
      </b-form-group>

      <!-- Product Code -->
      <b-form-group class="required-control">
        <label class="d-block">Mã sản phẩm:</label>
        <b-form-input
          size="sm"
          v-model="localValue.code"
          placeholder="Nhập mã sản phẩm"
          :state="validationState('code')"
          @change="
            onValueChanged('code');
            $emit('generate-child');
          "
          @keydown.space.prevent
        ></b-form-input>

        <b-form-invalid-feedback
          v-show="!validation.code.required && validation.code.$error"
          id="input-product-code-required-live-feedback"
        >
          Yêu cầu nhập Mã sản phẩm.
        </b-form-invalid-feedback>

        <b-form-invalid-feedback
          :state="validation.code.maxLength"
          v-if="!validation.code.maxLength"
          id="input-product-code-max-lenght-live-feedback"
          >Vui lòng nhập mã nhỏ hơn 50 kí tự</b-form-invalid-feedback
        >
        <b-form-invalid-feedback
          :state="validation.code.minLength"
          v-if="!validation.code.minLength"
          id="input-product-code-min-lenght-live-feedback"
          >Vui lòng nhập mã lớn hơn 3 kí tự</b-form-invalid-feedback
        >
        <b-form-invalid-feedback v-if="!validation.code.hasSpecialCharacters"
          >Mã sản phẩm không được chứa các ký tự đặc biệt:
          <span class="font-weight-bolder bg-light-danger">
            '`~!@#$%^&amp;*(),;"&lt;&gt;?/\,_
          </span></b-form-invalid-feedback
        >
        <b-form-invalid-feedback v-if="!validation.code.checkAscent"
          >Mã sản phẩm không được chứa kí tự tiếng việt</b-form-invalid-feedback
        >
      </b-form-group>

      <!-- Barcode -->
      <b-form-group>
        <label class="d-block">Mã vạch sản phẩm:</label>
        <b-form-input
          id="input-2"
          size="sm"
          v-model="localValue.barCode"
          placeholder="Nhập mã vạch sản phẩm"
          @change="
            onValueChanged('barcode');
            $emit('generate-child');
          "
        ></b-form-input>
      </b-form-group>

      <!-- Parent Product -->
      <b-form-group>
        <label class="d-block">Sản phẩm cha:</label>
        <Autosuggest
          :model="localValue.selectedParent"
          :suggestions="filteredOptions"
          placeholder="sản phẩm cha"
          :limit="10"
          :clear-on-change="true"
          @select="$emit('parent-selected', $event)"
          @change="$emit('parent-changed', $event)"
          suggestionName="suggestionName"
        />
      </b-form-group>

      <!-- Product Category -->
      <b-form-group class="required-control">
        <label>Danh mục sản phẩm:</label>
        <Autosuggest
          :model="localValue.selectedCate"
          :suggestions="filteredCategories"
          :placeholder="'danh mục sản phẩm'"
          :limit="200"
          @select="$emit('category-selected', $event)"
          @change="$emit('category-changed', $event)"
          :state="validationState('selectedCate')"
          errorMessages="Yêu cầu chọn Danh mục sản phẩm."
          suggestionName="suggestionName"
        />
        <span v-if="showErrorCate" class="text-danger">
          Vui lòng chọn 1 mục trong Danh mục sản phẩm
        </span>
      </b-form-group>

      <!-- Warranty Months -->
      <b-form-group>
        <label class="d-block">Số tháng bảo hành:</label>
        <b-form-input
          size="sm"
          type="number"
          v-model="localValue.warrantyMonthNo"
          required
          placeholder="Nhập số tháng bảo hành"
          class="text-right"
          @change="onValueChanged('warrantyMonthNo')"
          min="0"
        ></b-form-input>
      </b-form-group>

      <!-- Product Type -->
      <b-form-group>
        <label class="d-block">Loại sản phẩm:</label>
        <b-form-select
          class="select-style"
          size="sm"
          v-model="localValue.selectedType"
          :options="productTypes"
          value-field="id"
          text-field="name"
          @change="onTypeChanged"
        >
          <template v-slot:first>
            <b-form-select-option :value="null" disabled>
              Chọn loại sản phẩm
            </b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>

      <!-- Brand -->
      <b-form-group>
        <label class="d-block"> Thương hiệu: </label>
        <b-input-group>
          <Autosuggest
            :model="localValue.searchBrandName"
            :suggestions="filteredBrands"
            :placeholder="'thương hiệu'"
            :limit="200"
            @select="$emit('brand-selected', $event)"
            @change="$emit('brand-changed', $event)"
          />
          <b-input-group-append style="height: 2.55rem">
            <span @click="$emit('add-brand')" class="input-group-text">
              <i class="fas fa-plus"></i>
            </span>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>

      <!-- Notes -->
      <b-form-group>
        <label class="d-block">Lưu ý sản phẩm:</label>
        <b-form-textarea
          size="sm"
          v-model="localValue.note"
          :placeholder="'Thêm lưu ý sản phẩm'"
          :rows="6"
          :max-rows="8"
          @change="onValueChanged('note')"
        ></b-form-textarea>
      </b-form-group>

      <!-- Status -->
      <b-form-group>
        <label class="d-block">Trạng thái:</label>
        <b-form-select
          class="select-style"
          v-model="localValue.selectedStatus"
          :options="statuses"
          required
          value-field="id"
          text-field="name"
          size="sm"
          @change="onValueChanged('selectedStatus')"
        >
          <template v-slot:first>
            <b-form-select-option :value="null" disabled
              >--Chọn trạng thái--
            </b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>
    </b-col>

    <!-- Column 2: Transaction Information -->
    <b-col>
      <h4 style="color='rgb(24, 28, 50)'">Thông tin thuế</h4>

      <!-- VAT Code -->
      <b-form-group v-if="hasVatPermission">
        <label class="d-block mt-4">Mã sản phẩm VAT:</label>
        <b-form-input
          size="sm"
          v-model="localValue.productCodeVat"
          required
          placeholder="Nhập mã sản phẩm VAT"
          @change="onValueChanged('productCodeVat')"
        ></b-form-input>
      </b-form-group>

      <!-- VAT Name -->
      <b-form-group v-if="hasVatPermission">
        <label class="d-block"> Tên sản phẩm VAT: </label>
        <b-form-input
          size="sm"
          v-model="localValue.productNameVat"
          required
          placeholder="Nhập tên sản phẩm VAT"
          @change="onValueChanged('productNameVat')"
        ></b-form-input>
      </b-form-group>

      <!-- Brand Code -->
      <b-form-group>
        <label class="d-block"> Mã hãng: </label>
        <b-form-input
          size="sm"
          v-model="localValue.productBrandCode"
          required
          placeholder="Nhập mã hãng"
          @change="onValueChanged('productBrandCode')"
        ></b-form-input>
      </b-form-group>

      <b-form-group>
        <label class="d-block"> Alias: </label>
        <b-form-input
          size="sm"
          v-model="localValue.alias"
          required
          placeholder="Nhập alias"
          @change="onValueChanged('alias')"
        ></b-form-input>
      </b-form-group>

      <b-form-group>
        <label class="d-block"> SKU: </label>
        <b-form-input
          size="sm"
          v-model="localValue.sku"
          placeholder="Nhập SKU"
          @change="onValueChanged('sku')"
        ></b-form-input>
      </b-form-group>

      <!-- VAT -->
      <b-form-group :class="{ 'required-control': !isProductService }">
        <label class="d-block"> VAT: </label>
        <b-form-select
          class="select-style"
          size="sm"
          v-model="localValue.productVat"
          :state="validationState('productVat')"
          :options="[
            {
              id: null,
              name: 'Chọn thuế',
            },
            {
              id: -1,
              name: 'KCT',
            },
            {
              id: 5,
              name: '5%',
            },
            {
              id: 8,
              name: '8%',
            },
            {
              id: 10,
              name: '10%',
            },
          ]"
          value-field="id"
          text-field="name"
          @change="onValueChanged('productVat')"
        >
        </b-form-select>
        <b-form-invalid-feedback v-if="!isProductService">
          Yêu cầu nhập thuế suất. Thông tin liên hệ phòng kế toán.
        </b-form-invalid-feedback>
      </b-form-group>

      <!-- Unit -->
      <b-form-group :class="{ 'required-control': !isProductService }">
        <label class="d-block"> Đơn vị tính: </label>
        <b-form-select
          class="select-style"
          size="sm"
          v-model="localValue.unitId"
          :options="units"
          value-field="id"
          text-field="name"
          :state="validationState('unitId')"
          @change="onValueChanged('unitId')"
        >
        </b-form-select>
        <b-form-invalid-feedback v-if="!isProductService">
          Yêu cầu chọn đơn vị tính.
        </b-form-invalid-feedback>
      </b-form-group>
    </b-col>

    <!-- Column 3: Properties -->
    <b-col>
      <h4 style="color='rgb(24, 28, 50)'">Thông tin giao dịch</h4>

      <!-- Import Price -->
      <b-form-group>
        <label class="d-block mt-4">Giá nhập:</label>
        <b-form-input
          size="sm"
          v-model="localValue.importPrice"
          class="text-right"
          @change="
            onValueChanged('importPrice');
            $emit('generate-child');
          "
          v-mask="mask"
          disabled
        ></b-form-input>
      </b-form-group>

      <!-- Retail Price -->
      <b-form-group>
        <label class="d-block"> Giá bán lẻ: </label>
        <b-form-input
          id="input-2"
          size="sm"
          v-model="localValue.salePrice"
          placeholder="Nhập giá bán lẻ"
          class="text-right"
          v-mask="mask"
          @change="
            onValueChanged('salePrice');
            $emit('generate-child');
          "
        ></b-form-input>
      </b-form-group>

      <!-- Wholesale Price -->
      <b-form-group>
        <label class="d-block"> Giá bán buôn: </label>
        <b-form-input
          size="sm"
          v-model="localValue.wholesalePrice"
          required
          placeholder="Nhập giá bán buôn"
          class="text-right"
          v-mask="mask"
          @change="
            onValueChanged('wholesalePrice');
            $emit('generate-child');
          "
        ></b-form-input>
      </b-form-group>

      <!-- Listed Price -->
      <b-form-group>
        <label> Giá niêm yết: </label>
        <b-form-input
          size="sm"
          v-model="localValue.listedPrice"
          placeholder="Nhập giá niêm yết"
          class="text-right"
          @change="
            onValueChanged('listedPrice');
            $emit('generate-child');
          "
          v-mask="mask"
        ></b-form-input>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import { currencyMask } from '@/utils/common';
import localData from '@/utils/saveDataToLocal';
import { PRODUCT_TYPE } from '@/utils/enum';

export default {
  name: 'ProductInformationSection',
  components: {
    Autosuggest,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    validationState: {
      type: Function,
      required: true,
    },
    units: {
      type: Array,
      default: () => [],
    },
    statuses: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
    filteredCategories: {
      type: Array,
      default: () => [],
    },
    brands: {
      type: Array,
      default: () => [],
    },
    filteredBrands: {
      type: Array,
      default: () => [],
    },
    productTypes: {
      type: Array,
      default: () => [],
    },
    filteredOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localValue: { ...this.value },
      mask: currencyMask,
      showErrorCate: false,
      showErrorBrand: false,
    };
  },
  computed: {
    hasVatPermission() {
      return localData.checkPermission('PRODUCT_VAT_UPSERT');
    },
    isProductService() {
      return this.localValue.selectedType === PRODUCT_TYPE.PRODUCT_SERVICE;
    },
  },
  watch: {
    value: {
      handler(newVal) {
        this.localValue = { ...newVal };
      },
      deep: true,
    },
  },
  methods: {
    onValueChanged() {
      this.$emit('input', { ...this.localValue });
    },
    onTypeChanged() {
      this.onValueChanged('selectedType');
      this.$emit('type-selected');
    },
  },
};
</script>
